import React from 'react';

const SearchResultsContext = React.createContext(null);

export default SearchResultsContext;
